module.exports = __webpack_public_path__ + "static/img/beans.077a142b.png";